import { useCookies } from '@vueuse/integrations/useCookies'

export const request = (path: RequestInfo | URL, init?: RequestInit): Promise<Response> => {
    const cookies = useCookies(['token'])
    // const user_type = useCookie('user_type');
    const config = { ...init }
    const newHeaders = new Headers(config.headers);

    newHeaders.append("Accept", 'application/json; charset=UTF-8');
    newHeaders.append("Authorization", 'Bearer ' + cookies.get('token'));

    config.headers = newHeaders;

    const url = `${ process.env.VUE_APP_API_ENDPOINT }${ path }`

    return fetch(url, config).then(async function(response) {
        if (response.status === 401) {
            cookies.set('token', null);
        }

        return response;
    });
}